import _ from 'lodash'
import { colorVars } from '../constants/colorVars'
import { lightenColor } from './lightenColor'

const colorLongToShort = (colorName: string): string =>
  _.camelCase(colorName.substring(8))

const colorShortToLong = (colorName: string): string =>
  _.camelCase(`utkColor${_.startCase(colorName)}`)

const getCssColorFromColorName = (colorName: string): string =>
  colorVars[colorShortToLong(colorName) as keyof typeof colorVars]

const INHERIT = 'inherit'

const colorOptions = _.keys(colorVars).map(colorLongToShort)

// keeping this colorVars export for backwards compatibility
export {
  colorVars,
  colorLongToShort,
  colorShortToLong,
  getCssColorFromColorName,
  INHERIT,
  lightenColor,
  colorOptions,
}
